import { LottieTokens, } from '@voltmoney/schema';
export const lottieTokensMap = {
    [LottieTokens.Welcome]: require('./assets/welcome.json'),
    [LottieTokens.Confetti]: require('./assets/fall-from-the-sky.json'),
    [LottieTokens.Loading]: require('./assets/tickLoad.json'),
    [LottieTokens.UnlockNew]: require('./assets/unlockNew.json'),
    [LottieTokens.LoadingSplash]: require('./assets/loading.json'),
    [LottieTokens.Gift]: require('./assets/gift.json'),
    [LottieTokens.SandTimer]: require('./assets/sand_timer.json'),
    [LottieTokens.PartyPopper]: require('./assets/party-popper.json'),
    [LottieTokens.SSOLogin]: require('./assets/ssoLottie.json'),
    [LottieTokens.Success]: require('./assets/success.json'),
    [LottieTokens.PhonePe_Success]: require('./assets/phonePe_success.json'),
    [LottieTokens.PaymentSuccess]: require('./assets/paymentSuccess.json'),
    [LottieTokens.kyc_loading]: require('./assets/kyc_loading.json'),
    [LottieTokens.Enhance_Limit_Success]: require('./assets/enhance-limit-success.json'),
    [LottieTokens.Fetch_loading]: require('./assets/fetch_funds_animation.json')
};
